'use client';

import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

// ---------------- import
// icon
import icon_search_01 from './icon/icon_search_01.svg';
import icon_close_01 from './icon/icon_close_01.svg';
import icon_cart_01 from './icon/icon_cart_01.svg';
import icon_copy from './icon/icon_copy.svg';
import icon_alarm_01 from './icon/icon_alarm_01.svg';
import icon_alarm_02 from './icon/icon_alarm_02.svg';
import icon_alarm_03 from './icon/icon_alarm_03.svg';
import icon_alarm_04 from './icon/icon_alarm_04.svg';
import icon_back_01 from './icon/icon_back_01.svg';
import icon_home_01 from './icon/icon_home_01.svg';
import icon_home_02 from './icon/icon_home_02.svg';
import icon_arrow_up_01 from './icon/icon_arrow_up_01.svg';
import icon_arrow_down_01 from './icon/icon_arrow_down_01.svg';
import icon_instagram_01 from './icon/icon_instagram_01.svg';
import icon_cate_01 from './icon/icon_cate_01.svg';
import icon_del_01 from './icon/icon_del_01.svg';
import icon_del_02 from './icon/icon_del_02.svg';
import icon_del_03 from './icon/icon_del_03.svg';
import icon_discovery_01 from './icon/icon_discovery_01.svg';
import icon_heart_01 from './icon/icon_heart_01.svg';
import icon_my_01 from './icon/icon_my_01.svg';
import icon_history_01 from './icon/icon_history_01.svg';
import icon_history_02 from './icon/icon_history_02.svg';
import icon_checkbox_01 from './icon/icon_checkbox_01.svg';
import icon_checkbox_02 from './icon/icon_checkbox_02.svg';
import icon_checkbox_03 from './icon/icon_checkbox_03.svg';
import icon_radio_01 from './icon/icon_radio_01.svg';
import icon_radio_02_checked from './icon/icon_radio_02_checked.svg';
import icon_play_01 from './icon/icon_play_01.svg';
import icon_play_02 from './icon/icon_play_02.svg';
import icon_play_03 from './icon/icon_play_03.svg';
import icon_play_04 from './icon/icon_play_04.svg';
import icon_play_05 from './icon/icon_play_05.svg';
import icon_heart_02 from './icon/icon_heart_02.svg';
import icon_heart_03 from './icon/icon_heart_03.svg';
import icon_star_01 from './icon/icon_star_01.svg';
import icon_star_02 from './icon/icon_star_02.svg';
import icon_ai_01 from './icon/icon_ai_01.svg';
import icon_style_check from './icon/icon_style_check.svg';
import icon_login_01 from './icon/icon_login_01.svg';
import icon_heart_04 from './icon/icon_heart_04.svg';
import icon_my_02 from './icon/icon_my_02.svg';
import icon_cart_02 from './icon/icon_cart_02.svg';
import icon_search_02 from './icon/icon_search_02.svg';
import icon_cate_02 from './icon/icon_cate_02.svg';
import icon_logout_01 from './icon/icon_logout_01.svg';
import icon_arrow_down_02 from './icon/icon_arrow_down_02.svg';
import icon_close_02 from './icon/icon_close_02.svg';
import icon_close_03 from './icon/icon_close_03.svg';
import icon_close_04 from './icon/icon_close_04.svg';
import icon_close_05 from './icon/icon_close_05.svg';
import icon_clock_01 from './icon/icon_clock_01.svg';
import icon_clock_filled from './icon/icon_clock_filled.svg';
import icon_clock_filled2 from './icon/icon_clock_filled2.svg';
import icon_notice_01 from './icon/icon_notice_01.svg';
import icon_arrow_up_02 from './icon/icon_arrow_up_02.svg';
import icon_btn_main_bannerList from './icon/icon_btn_main_bannerList.svg';
import icon_arrow_right_01 from './icon/icon_arrow_right_01.svg';
import icon_arrow_right_02 from './icon/icon_arrow_right_02.svg';
import icon_arrow_right_03 from './icon/icon_arrow_right_03.svg';
import icon_arrow_right_03_d from './icon/icon_arrow_right_03_d.svg';
import icon_check_01 from './icon/icon_check_01.svg';
import icon_check_03 from './icon/icon_check_03.svg';
import icon_check_04 from './icon/icon_check_04.svg';
import icon_select_arrow_01 from './icon/icon_select_arrow_01.svg';
import icon_select_arrow_02 from './icon/icon_select_arrow_02.svg';
import icon_wtach_01 from './icon/icon_wtach_01.svg';
import icon_wtach_02 from './icon/icon_wtach_02.svg';
import icon_w_only_01 from './icon/icon_w_only_01.svg';
import icon_w_only_02_white from './icon/icon_w_only_02_white.svg';
import icon_w_only_02_black from './icon/icon_w_only_02_black.svg';
import icon_circle_arrow_01 from './icon/icon_circle_arrow_01.svg';
import icon_refresh_01 from './icon/icon_refresh_01.svg';
import icon_refresh_02 from './icon/icon_refresh_02.svg';
import icon_refresh_03 from './icon/icon_refresh_03.svg';
import icon_refresh_04 from './icon/icon_refresh_04.svg';
import icon_arrow_down_03 from './icon/icon_arrow_down_03.svg';
import icon_arrow_down_04 from './icon/icon_arrow_down_04.svg';
import icon_arrow_down_05 from './icon/icon_arrow_down_05.svg';
import icon_arrow_down_06 from './icon/icon_arrow_down_06.svg';
import icon_arrow_down_07 from './icon/icon_arrow_down_07.svg';
import icon_download_02 from './icon/icon_download_02.svg';
import icon_arrow_right_16 from './icon/icon_arrow_right_16.svg';
import icon_arrow_right_04 from './icon/icon_arrow_right_04.svg';
import icon_arrow_right_05 from './icon/icon_arrow_right_05.svg';
import icon_arrow_right_06 from './icon/icon_arrow_right_06.svg';
import icon_arrow_right_07 from './icon/icon_arrow_right_07.svg';
import icon_arrow_right_08 from './icon/icon_arrow_right_08.svg';
import icon_arrow_right_14 from './icon/icon_arrow_right_14.svg';
import icon_arrow_right_15 from './icon/icon_arrow_right_15.svg';
import icon_square_arrow_01 from './icon/icon_square_arrow_01.svg';
import icon_eye_01 from './icon/icon_eye_01.svg';
import icon_heart_05 from './icon/icon_heart_05.svg';
import icon_heart_06 from './icon/icon_heart_06.svg';
import icon_cart_03 from './icon/icon_cart_03.svg';
import icon_share_01 from './icon/icon_share_01.svg';
import icon_arrow_right_09 from './icon/icon_arrow_right_09.svg';
import icon_arrow_right_10 from './icon/icon_arrow_right_10.svg';
import icon_arrow_right_11 from './icon/icon_arrow_right_11.svg';
import icon_arrow_right_12 from './icon/icon_arrow_right_12.svg';
import icon_arrow_right_13 from './icon/icon_arrow_right_13.svg';
import icon_kakao_01 from './icon/icon_kakao_01.svg';
import icon_kakao_02 from './icon/icon_kakao_02.svg';
import icon_facebook_01 from './icon/icon_facebook_01.svg';
import icon_url_01 from './icon/icon_url_01.svg';
import icon_url_02 from './icon/icon_url_02.svg';
import icon_question_01 from './icon/icon_question_01.svg';
import icon_question_02 from './icon/icon_question_02.svg';
import icon_loading_01 from './icon/icon_loading_01.svg';
import icon_soundoff_01 from './icon/icon_soundoff_01.svg';
import icon_soundon_01 from './icon/icon_soundon_01.svg';
import icon_soundoff_02 from './icon/icon_soundoff_02.svg';
import icon_soundon_02 from './icon/icon_soundon_02.svg';
import icon_plus_01 from './icon/icon_plus_01.svg';
import icon_error_01 from './icon/icon_error_01.svg';
import icon_error_02 from './icon/icon_error_02.svg';
import icon_error_03 from './icon/icon_error_03.svg';
import icon_profile_01 from './icon/icon_profile_01.svg';
import icon_official_new from './icon/icon_official_new.svg';
import icon_official_w from './icon/icon_official_w.svg';
import icon_official_b from './icon/icon_official_b.svg';
import icon_official_c from './icon/icon_official_c.svg';
import icon_related_01 from './icon/icon_related_01.svg';
import icon_my_03 from './icon/icon_my_03.svg';
import icon_replay_01 from './icon/icon_replay_01.svg';
import iconArrowGray4 from './icon/icon_arrow_gray4.svg';
import iconShare02 from './icon/icon_share_02.svg';
import iconShare03 from './icon/icon_share_03.svg';
import icon_bookmark_01 from './icon/icon_bookmark_01.svg';
import icon_heart_w13 from './icon/icon_heart_light_w13.svg';
import icon_heart_w16 from './icon/icon_heart_light_w16.svg';
import icon_heart_w18 from './icon/icon_heart_light_w18.svg';
import icon_heart_w24 from './icon/icon_heart_light_w24.svg';
import icon_heart_dark_w13 from './icon/icon_heart_dark_w13.svg';
import icon_heart_dark_w16 from './icon/icon_heart_dark_w16.svg';
import icon_heart_dark_w18 from './icon/icon_heart_dark_w18.svg';
import icon_heart_dark_w24 from './icon/icon_heart_dark_w24.svg';
import icon_outlink_01 from './icon/icon_outlink01.svg';
import icon_download_01 from './icon/icon_download_01.svg';
import icon_attend_check from './icon/icon_attend_check.svg';
import icon_attend_check_today from './icon/icon_attend_check_today.svg';
import icon_attend_bg from './icon/icon_attend_bg.svg';
import icon_today_point from './icon/icon_today_point.svg';
import icon_add_01 from './icon/icon_add_01.svg';
import icon_view_01 from './icon/icon_view_01.svg';
import icon_view_02 from './icon/icon_view_02.svg';
import icon_check_02 from './icon/icon_check_02.svg';
import icon_plus_02 from './icon/icon_plus_02.svg';
import icon_new_chat from './icon/icon_new_chat.svg';
import icon_info_01 from './icon/icon_info_01.svg';
import icon_info_02 from './icon/icon_info_02.svg';
import icon_like_01 from './icon/icon_like_01.svg';
import icon_dislike_01 from './icon/icon_dislike_01.svg';
import icon_copy_01 from './icon/icon_copy_01.svg';
import icon_sparkle01 from './icon/icon_sparkle01.svg';
import icon_sparkle02 from './icon/icon_sparkle02.svg';

// action bar like app
import icon_home_text from './icon/icon_home_text.svg';
import icon_cate_text from './icon/icon_cate_text.svg';
import icon_search_text from './icon/icon_search_text.svg';
import icon_heart_text from './icon/icon_heart_text.svg';
import icon_my_text from './icon/icon_my_text.svg';
import icon_home_text_on from './icon/icon_home_text_on.svg';
import icon_cate_text_on from './icon/icon_cate_text_on.svg';
import icon_search_text_on from './icon/icon_search_text_on.svg';
import icon_heart_text_on from './icon/icon_heart_text_on.svg';
import icon_my_text_on from './icon/icon_my_text_on.svg';
import icon_home_text_dark from './icon/icon_home_text_dark.svg';
import icon_cate_text_dark from './icon/icon_cate_text_dark.svg';
import icon_search_text_dark from './icon/icon_search_text_dark.svg';
import icon_heart_text_dark from './icon/icon_heart_text_dark.svg';
import icon_my_text_dark from './icon/icon_my_text_dark.svg';
import icon_home_text_dark_on from './icon/icon_home_text_dark_on.svg';
import icon_cate_text_dark_on from './icon/icon_cate_text_dark_on.svg';
import icon_search_text_dark_on from './icon/icon_search_text_dark_on.svg';
import icon_heart_text_dark_on from './icon/icon_heart_text_dark_on.svg';
import icon_my_text_dark_on from './icon/icon_my_text_dark_on.svg';
import icon_arrow_h10 from './icon/icon_arrow_h10.svg';
import icon_select_category2 from './icon/icon_select_category2.svg';
import icon_column_02 from './icon/icon_column_02.svg';
import icon_column_03 from './icon/icon_column_03.svg';

// btn
import btnActionbarCateN32 from './btn/btn_actionbar_cate_n_32.svg';
import btnActionbarHeartN32 from './btn/btn_actionbar_heart_n_32.svg';
import btnActionbarHistoryN32 from './btn/btn_actionbar_history_n_32.svg';
import btnActionbarHome32 from './btn/btn_actionbar_home_32.svg';
import btnActionbarMyN32 from './btn/btn_actionbar_my_n_32.svg';
import btn_reset_filter from './btn/btn_reset_filter.svg';
import btn_folder from './btn/btn_folder.svg';
import btn_top_old from './btn/btn_top_old.svg';
import btn_send from './btn/btn_send.svg';
import btn_send_stop from './btn/btn_send_stop.svg';
import btn_attach from './btn/btn_attach.svg';
import btn_bottom from './btn/btn_bottom.svg';

import { AttendEvent } from './bg/AttendEvent';

// logo
import logo_wcon_01 from './logo/logo_wcon_01.svg';
import logo_wcon_02 from './logo/logo_wcon_02.svg';
import logo_wcon_03 from './logo/logo_wcon_03.svg';
import logo_wcon_04 from './logo/logo_wcon_04.svg';
import { LogoWai } from './logo/LogoWai';
import logo_wai_txt01 from './logo/logo_wai_txt01.svg';
import logo_wcon_05 from './logo/logo_wcon_05.svg';

// bg
import coupon_bg_img_01 from './bg/coupon_bg_img_01.svg';
import coupon_bg_img_01_pc from './bg/coupon_bg_img_01_pc.svg';
import coupon_bg_img_02 from './bg/coupon_bg_img_02.svg';

// ---------------- utils
const getStyle = (w: number, h: number) => css`
  ${mixin.getSizeBox(w, h)}
`;

// ---------------- styled
// icon
export const IconCopy01 = styled(icon_copy_01)`
  ${getStyle(20, 20)}
`;
export const IconSparkle01 = styled(icon_sparkle01)`
  ${getStyle(20, 20)}
`;
export const IconSparkle02 = styled(icon_sparkle02)`
  ${getStyle(16, 16)}
`;
export const IconLike01 = styled(icon_like_01)`
  ${getStyle(18, 18)}
`;
export const IconDislike01 = styled(icon_dislike_01)`
  ${getStyle(18, 18)}
`;
export const IconInfo01 = styled(icon_info_01)`
  ${getStyle(14, 14)}
`;
export const IconInfo02 = styled(icon_info_02)`
  ${getStyle(15, 15)}
`;
export const IconNewChat = styled(icon_new_chat)`
  ${getStyle(24, 24)}
`;
export const IconPlus02 = styled(icon_plus_02)`
  ${getStyle(11, 10)}
`;
export const IconCheck02 = styled(icon_check_02)`
  ${getStyle(11, 8)}
`;
export const IconView01 = styled(icon_view_01)`
  ${getStyle(15, 9)}
`;
export const IconView02 = styled(icon_view_02)`
  ${getStyle(16, 16)}
`;
export const IconAdd01 = styled(icon_add_01)`
  ${getStyle(26, 26)}
`;
export const IconHeartDarkW13 = styled(icon_heart_dark_w13)`
  ${getStyle(13, 13)}
`;
export const IconHeartDarkW16 = styled(icon_heart_dark_w16)`
  ${getStyle(16, 16)}
`;
export const IconHeartDarkW18 = styled(icon_heart_dark_w18)`
  ${getStyle(18, 18)}
`;
export const IconHeartDarkW24 = styled(icon_heart_dark_w24)`
  ${getStyle(24, 24)}
`;
export const IconHeartW13 = styled(icon_heart_w13)`
  ${getStyle(13, 13)}
`;
export const IconHeartW16 = styled(icon_heart_w16)`
  ${getStyle(16, 16)}
`;
export const IconHeartW18 = styled(icon_heart_w18)`
  ${getStyle(18, 18)}
`;
export const IconHeartW24 = styled(icon_heart_w24)`
  ${getStyle(24, 24)}
`;
export const IconShare02 = styled(iconShare02)`
  ${getStyle(15, 15)}
`;
export const IconShare03 = styled(iconShare03)`
  ${getStyle(18, 18)}
`;
export const IconArrowG4 = styled(iconArrowGray4)`
  ${getStyle(3, 4)}
`;
export const IconProfile01 = styled(icon_profile_01)`
  ${getStyle(24, 24)}
`;
export const IconOfficialNew = styled(icon_official_new)`
  ${getStyle(14, 14)}
`;
export const IconOfficialW = styled(icon_official_w)`
  ${getStyle(14, 14)}
`;
export const IconOfficialB = styled(icon_official_b)`
  ${getStyle(14, 14)}
`;
export const IconOfficialC = styled(icon_official_c)`
  ${getStyle(14, 14)}
`;
export const IconRelated01 = styled(icon_related_01)`
  ${getStyle(14, 14)}
`;
export const IconError01 = styled(icon_error_01)`
  ${getStyle(62, 58)}
`;
export const IconError02 = styled(icon_error_02)`
  ${getStyle(50, 60)}
`;
export const IconError03 = styled(icon_error_03)`
  ${getStyle(62, 54)}
`;
export const IconSoundoff01 = styled(icon_soundoff_01)`
  ${getStyle(24, 24)}
`;
export const IconSoundon01 = styled(icon_soundon_01)`
  ${getStyle(24, 24)}
`;
export const IconSoundoff02 = styled(icon_soundoff_02)`
  ${getStyle(24, 24)}
`;
export const IconSoundon02 = styled(icon_soundon_02)`
  ${getStyle(24, 24)}
`;
export const IconLoading01 = styled(icon_loading_01)`
  ${getStyle(24, 24)}
`;
export const IconKakao01 = styled(icon_kakao_01)`
  ${getStyle(18, 16)}
`;
export const IconFacebook01 = styled(icon_facebook_01)`
  ${getStyle(9, 17)}
`;
export const IconUrl01 = styled(icon_url_01)`
  ${getStyle(21, 9)}
`;
export const IconRefresh02 = styled(icon_refresh_02)`
  ${getStyle(20, 20)}
`;
export const IconRefresh03 = styled(icon_refresh_03)`
  ${getStyle(12, 13)}
`;
export const IconRefresh04 = styled(icon_refresh_04)`
  ${getStyle(14, 14)}
`;
export const IconArrowRight09 = styled(icon_arrow_right_09)`
  ${getStyle(6, 9)}
`;
export const IconArrowRight10 = styled(icon_arrow_right_10)`
  ${getStyle(24, 24)}
`;
export const IconArrowRight11 = styled(icon_arrow_right_11)`
  ${getStyle(8, 12)}
`;
export const IconArrowRight12 = styled(icon_arrow_right_12)`
  ${getStyle(14, 14)}
`;
export const IconArrowRight13 = styled(icon_arrow_right_13)`
  ${getStyle(14, 14)}
`;
export const IconShare01 = styled(icon_share_01)`
  ${getStyle(18, 18)}
`;
export const IconAlarm02 = styled(icon_alarm_02)`
  ${getStyle(10, 13)}
`;
export const IconAlarm03 = styled(icon_alarm_03)`
  ${getStyle(16, 16)}
`;
export const IconAlarm04 = styled(icon_alarm_04)`
  ${getStyle(16, 16)}
`;
export const IconEye01 = styled(icon_eye_01)`
  ${getStyle(12, 9)}
`;
export const IconHeart05 = styled(icon_heart_05)`
  ${getStyle(12, 10)}
`;
export const IconHeart06 = styled(icon_heart_06)`
  ${getStyle(16, 16)}
`;
export const IconCart03 = styled(icon_cart_03)`
  ${getStyle(10, 11)}
`;
export const IconArrowRight16 = styled(icon_arrow_right_16)`
  ${getStyle(14, 14)}
`;
export const IconArrowRight05 = styled(icon_arrow_right_05)`
  ${getStyle(8, 13)}
`;
export const IconArrowRight06 = styled(icon_arrow_right_06)`
  ${getStyle(12, 12)}
`;
export const IconArrowRight07 = styled(icon_arrow_right_07)`
  ${getStyle(15, 12)}
`;
export const IconArrowRight08 = styled(icon_arrow_right_08)`
  ${getStyle(42, 42)}
`;
export const IconArrowRight14 = styled(icon_arrow_right_14)`
  ${getStyle(20, 20)}
`;
export const IconArrowRight15 = styled(icon_arrow_right_15)`
  ${getStyle(14, 25)}
`;
export const IconRefresh01 = styled(icon_refresh_01)`
  ${getStyle(17, 16)}
`;
export const IconArrowRight02 = styled(icon_arrow_right_02)`
  ${getStyle(8, 13)}
`;
export const IconArrowRight01 = styled(icon_arrow_right_01)`
  ${getStyle(7, 12)}
`;
export const IconArrowRight03 = styled(icon_arrow_right_03)`
  ${getStyle(16, 16)}
`;
export const IconArrowRight03D = styled(icon_arrow_right_03_d)`
  ${getStyle(16, 16)}
`;
export const IconArrowUp02 = styled(icon_arrow_up_02)`
  ${getStyle(10, 11)}
`;
export const IconClose05 = styled(icon_close_05)`
  ${getStyle(12, 12)}
`;
export const IconClose04 = styled(icon_close_04)`
  ${getStyle(20, 20)}
`;
export const IconClose03 = styled(icon_close_03)`
  ${getStyle(10, 9)}
`;
export const IconClose02 = styled(icon_close_02)`
  ${getStyle(8, 9)}
`;
export const IconClock01 = styled(icon_clock_01)`
  ${getStyle(14, 14)}
`;
export const IconClockFilled = styled(icon_clock_filled)`
  ${getStyle(18, 18)}
`;
export const IconClockFilled2 = styled(icon_clock_filled2)`
  ${getStyle(14, 14)}
`;
export const IconNotice01 = styled(icon_notice_01)`
  ${getStyle(14, 14)}
`;
export const IconArrowDown02 = styled(icon_arrow_down_02)`
  ${getStyle(12, 12)}
`;
export const IconLogout01 = styled(icon_logout_01)`
  ${getStyle(21, 22)}
`;
export const IconCate02 = styled(icon_cate_02)`
  ${getStyle(18, 14)}
`;
export const IconSearch02 = styled(icon_search_02)`
  ${getStyle(21, 22)}
`;
export const IconLogin01 = styled(icon_login_01)`
  ${getStyle(21, 22)}
`;
export const IconHeart04 = styled(icon_heart_04)`
  ${getStyle(22, 20)}
`;
export const IconMy02 = styled(icon_my_02)`
  ${getStyle(22, 22)}
`;
export const IconCart02 = styled(icon_cart_02)`
  ${getStyle(20, 20)}
`;
export const IconStar01 = styled(icon_star_01)`
  ${getStyle(10, 10)}
`;
export const IconStar02 = styled(icon_star_02)`
  ${getStyle(16, 16)}
`;
export const IconAi01 = styled(icon_ai_01)`
  ${getStyle(16, 16)}
`;
export const IconStyleCheck = styled(icon_style_check)`
  ${getStyle(40, 40)}
`;
export const IconHeart03 = styled(icon_heart_03)`
  ${getStyle(10, 10)}
`;
export const IconHeart02 = styled(icon_heart_02)`
  ${getStyle(16, 14)}
`;
export const IconPlay01 = styled(icon_play_01)`
  ${getStyle(20, 20)}
`;
export const IconPlay02 = styled(icon_play_02)`
  ${getStyle(9, 10)}
`;
export const IconPlay03 = styled(icon_play_03)`
  ${getStyle(14, 14)}
`;
export const IconPlay04 = styled(icon_play_04)`
  ${getStyle(13, 14)}
`;
export const IconPlay05 = styled(icon_play_05)`
  ${getStyle(12, 12)}
`;
export const IconRadio01 = styled(icon_radio_01)`
  ${getStyle(20, 20)}
`;
export const IconRadio02Checked = styled(icon_radio_02_checked)`
  ${getStyle(20, 20)}
`;
export const IconCheckbox01 = styled(icon_checkbox_01)`
  ${getStyle(20, 20)}
`;
export const IconCheckbox02 = styled(icon_checkbox_02)`
  ${getStyle(17, 16)}
`;
export const IconCheckbox03 = styled(icon_checkbox_03)`
  ${getStyle(20, 20)}
`;
export const IconHistory01 = styled(icon_history_01)`
  ${getStyle(24, 24)}
`;
export const IconHistory02 = styled(icon_history_02)`
  ${getStyle(23, 22)}
`;
export const IconArrowUp01 = styled(icon_arrow_up_01)`
  ${getStyle(24, 24)}
`;
export const IconMy01 = styled(icon_my_01)`
  ${getStyle(26, 26)}
`;
export const IconHeart01 = styled(icon_heart_01)`
  ${getStyle(26, 26)}
`;
export const IconDel01 = styled(icon_del_01)`
  ${getStyle(16, 16)}
`;
export const IconDel02 = styled(icon_del_02)`
  ${getStyle(12, 12)}
`;
export const IconDel03 = styled(icon_del_03)`
  ${getStyle(8, 8)}
`;
export const IconDiscovery01 = styled(icon_discovery_01)`
  ${getStyle(26, 26)}
`;
export const IconCate01 = styled(icon_cate_01)`
  ${getStyle(26, 26)}
`;
export const IconHome02 = styled(icon_home_02)`
  ${getStyle(26, 26)}
`;
export const IconInsta01 = styled(icon_instagram_01)`
  ${getStyle(20, 20)}
`;
export const IconArrowDown01 = styled(icon_arrow_down_01)`
  ${getStyle(10, 7)}
`;
export const IconHome01 = styled(icon_home_01)`
  ${getStyle(20, 20)}
`;
export const IconBack01 = styled(icon_back_01)`
  ${getStyle(24, 24)}
`;
export const IconAlarm01 = styled(icon_alarm_01)`
  ${getStyle(24, 24)}
`;
export const IconCart01 = styled(icon_cart_01)`
  ${getStyle(24, 24)}
`;
export const IconCopy = styled(icon_copy)`
  ${getStyle(12, 12)}
`;
export const IconSearch01 = styled(icon_search_01)`
  ${getStyle(24, 24)}
`;
export const IconClose01 = styled(icon_close_01)`
  ${getStyle(16, 16)}
`;
export const IconBtnMainBannerList = styled(icon_btn_main_bannerList)`
  ${getStyle(36, 36)}
`;
export const IconCheck01 = styled(icon_check_01)`
  ${getStyle(12, 9)}
`;
export const IconCheck03 = styled(icon_check_03)`
  ${getStyle(16, 11)}
`;
export const IconCheck04 = styled(icon_check_04)`
  ${getStyle(23, 17)}
`;
export const IconSelArrow01 = styled(icon_select_arrow_01)`
  ${getStyle(10, 6)}
`;
export const IconSelArrow02 = styled(icon_select_arrow_02)`
  ${getStyle(6, 5)}
`;
export const IconWatch01 = styled(icon_wtach_01)`
  ${getStyle(18, 18)}
`;
export const IconWatch02 = styled(icon_wtach_02)`
  ${getStyle(10, 10)}
`;
export const IconWOnly01 = styled(icon_w_only_01)`
  ${getStyle(52, 19)}
`;
export const IconWOnly02White = styled(icon_w_only_02_white)`
  ${getStyle(40, 14)}
`;
export const IconWOnly02Black = styled(icon_w_only_02_black)`
  ${getStyle(40, 14)}
`;
export const IconCircleArrow01 = styled(icon_circle_arrow_01)`
  ${getStyle(33, 33)}
`;
export const IconArrowDown03 = styled(icon_arrow_down_03)`
  ${getStyle(14, 14)}
`;
export const IconArrowDown04 = styled(icon_arrow_down_04)`
  ${getStyle(20, 20)}
`;
export const IconArrowH10 = styled(icon_arrow_h10)`
  ${getStyle(6, 10)}
`;
export const IconSelectCate2 = styled(icon_select_category2)`
  ${getStyle(12, 12)}
`;
export const IconArrowDown05 = styled(icon_arrow_down_05)`
  ${getStyle(14, 14)}
`;
export const IconArrowDown06 = styled(icon_arrow_down_06)`
  ${getStyle(16, 16)}
`;
export const IconArrowDown07 = styled(icon_arrow_down_07)`
  ${getStyle(14, 8)}
`;
export const IconDownLoad02 = styled(icon_download_02)`
  ${getStyle(18, 19)}
`;
export const IconArrowRight04 = styled(icon_arrow_right_04)`
  ${getStyle(12, 12)}
`;
export const IconSquareArrow01 = styled(icon_square_arrow_01)`
  ${getStyle(28, 29)}
`;
export const IconQuestion01 = styled(icon_question_01)`
  ${getStyle(16, 16)}
`;
export const IconQuestion02 = styled(icon_question_02)`
  ${getStyle(14, 14)}
`;
export const IconPlus01 = styled(icon_plus_01)`
  ${getStyle(14, 14)}
`;
export const IconMy03 = styled(icon_my_03)`
  ${getStyle(25, 13)}
`;
export const IconReplay01 = styled(icon_replay_01)`
  ${getStyle(16, 16)}
`;
export const IconBookMark01 = styled(icon_bookmark_01)`
  ${getStyle(16, 16)}
`;
export const IconOutLink01 = styled(icon_outlink_01)`
  ${getStyle(10, 10)}
`;
export const IconDownload01 = styled(icon_download_01)`
  ${getStyle(20, 20)}
`;
export const IconAttendCheck = styled(icon_attend_check)`
  ${getStyle(24, 24)}
`;
export const IconAttendCheckToday = styled(icon_attend_check_today)`
  ${getStyle(24, 24)}
`;
export const IconAttendBg = styled(icon_attend_bg)`
  ${getStyle(32, 32)}
`;
export const IconTodayPoint = styled(icon_today_point)`
  ${getStyle(16, 16)}
`;

// action bar like app
export const IconHomeText = styled(icon_home_text)`
  ${getStyle(48, 44)}
`;
export const IconCateText = styled(icon_cate_text)`
  ${getStyle(48, 44)}
`;
export const IconSearchText = styled(icon_search_text)`
  ${getStyle(48, 44)}
`;
export const IconHeartText = styled(icon_heart_text)`
  ${getStyle(48, 44)}
`;
export const IconMyText = styled(icon_my_text)`
  ${getStyle(48, 44)}
`;
export const IconHomeTextOn = styled(icon_home_text_on)`
  ${getStyle(48, 44)}
`;
export const IconCateTextOn = styled(icon_cate_text_on)`
  ${getStyle(48, 44)}
`;
export const IconSearchTextOn = styled(icon_search_text_on)`
  ${getStyle(48, 44)}
`;
export const IconHeartTextOn = styled(icon_heart_text_on)`
  ${getStyle(48, 44)}
`;
export const IconMyTextOn = styled(icon_my_text_on)`
  ${getStyle(48, 44)}
`;
export const IconHomeTextDark = styled(icon_home_text_dark)`
  ${getStyle(48, 44)}
`;
export const IconCateTextDark = styled(icon_cate_text_dark)`
  ${getStyle(48, 44)}
`;
export const IconSearchTextDark = styled(icon_search_text_dark)`
  ${getStyle(48, 44)}
`;
export const IconHeartTextDark = styled(icon_heart_text_dark)`
  ${getStyle(48, 44)}
`;
export const IconMyTextDark = styled(icon_my_text_dark)`
  ${getStyle(48, 44)}
`;
export const IconHomeTextDarkOn = styled(icon_home_text_dark_on)`
  ${getStyle(48, 44)}
`;
export const IconCateTextDarkOn = styled(icon_cate_text_dark_on)`
  ${getStyle(48, 44)}
`;
export const IconSearchTextDarkOn = styled(icon_search_text_dark_on)`
  ${getStyle(48, 44)}
`;
export const IconHeartTextDarkOn = styled(icon_heart_text_dark_on)`
  ${getStyle(48, 44)}
`;
export const IconMyTextDarkOn = styled(icon_my_text_dark_on)`
  ${getStyle(48, 44)}
`;

export const AttendEventImg = styled(AttendEvent)`
  ${getStyle(195, 176)}
`;
export const IconKakao02 = styled(icon_kakao_02)`
  ${getStyle(40, 40)}
`;
export const IconUrl02 = styled(icon_url_02)`
  ${getStyle(40, 40)}
`;
export const IconColumn02 = styled(icon_column_02)`
  ${getStyle(16, 16)}
`;
export const IconColumn03 = styled(icon_column_03)`
  ${getStyle(16, 16)}
`;

// btn
export const BtnBottom = styled(btn_bottom)`
  ${getStyle(36, 36)}
`;
export const BtnSend = styled(btn_send)`
  ${getStyle(38, 38)}
`;
export const BtnSendStop = styled(btn_send_stop)`
  ${getStyle(38, 38)}
`;
export const BtnAttach = styled(btn_attach)`
  ${getStyle(28, 28)}
`;
export const BtnActnbrCate = styled(btnActionbarCateN32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrHeart = styled(btnActionbarHeartN32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrHistory = styled(btnActionbarHistoryN32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrHome = styled(btnActionbarHome32)`
  ${getStyle(32, 32)}
`;
export const BtnActnbrMy = styled(btnActionbarMyN32)`
  ${getStyle(32, 32)}
`;
export const BtnPageTopOld = styled(btn_top_old)`
  ${getStyle(40, 40)}
`;
export const BtnResetFilter = styled(btn_reset_filter)`
  ${getStyle(16, 12)}
`;
export const BtnFolder = styled(btn_folder)`
  ${getStyle(28, 28)}
`;

// logo
export const LogoWcon03 = styled(logo_wcon_03)`
  ${getStyle(60, 60)}
`;
export const LogoWcon02 = styled(logo_wcon_02)`
  ${getStyle(170, 22)}
`;
export const LogoWcon01 = styled(logo_wcon_01)`
  ${getStyle(119, 22)}
`;
export const LogoWcon04 = styled(logo_wcon_04)`
  ${getStyle(99, 13)}
`;
export const LogoWai01 = styled(LogoWai)`
  ${getStyle(200, 200)}
`;
export const LogoWaiTxt01 = styled(logo_wai_txt01)`
  ${getStyle(111, 15)}
`;
export const LogoWcon05 = styled(logo_wcon_05)`
  ${getStyle(60, 60)}
`;

// bg
export const CouponBgImg01 = styled(coupon_bg_img_01)`
  ${getStyle(290, 60)}
`;
export const CouponBgImg01Pc = styled(coupon_bg_img_01_pc)`
  ${getStyle(380, 68)}
`;
export const CouponBgImg02 = styled(coupon_bg_img_02)`
  ${getStyle(140, 132)}
`;
